import { QueryClient } from '@tanstack/vue-query'

/**
 * The single TanStack Query client for the console, provided at the app
 * root in `main.ts` — deliberately separate from Pinia. Vue Query owns
 * server cache/invalidation; Pinia holds session, RBAC context, and UI
 * prefs (admin-portal-specification.md §2). Nothing here reads or writes a
 * Pinia store, and no Pinia store should cache server response data.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
